import React, { Component } from 'react';
import { Col, FormControl, InputGroup, Row } from 'react-bootstrap';
import displayCurrency from '../../../helpers/displayCurrency';
import { Icon } from '../../components';
import { Button } from '../../../common/components';
import './OverrideFormControl.scss';

const InputGroupAddon = InputGroup.Addon;

const filterCurrency = (value) => {
  if (!value) {
    return '';
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

class OverrideFormControl extends Component {
  render() {
    const {
      input,
      meta,
      type,
      fieldSize,
      placeholder,
      addonBefore,
      monetaryValue,
      rows,
      note,
      currency,
      isCalc,
      className,
    } = this.props;
    const formControlComponent = (
      <InputGroup>
        {currency && (
          <InputGroupAddon className={'admin-fee-icon'}>
            <Icon name={isCalc ? 'spinner' : 'pound-sign'} spin={isCalc} />
          </InputGroupAddon>
        )}
        {addonBefore && <InputGroupAddon>{addonBefore}</InputGroupAddon>}
        <FormControl
          {...input}
          type={type}
          className={className}
          placeholder={currency ? filterCurrency(placeholder) : placeholder}
          //value={currency ? filterCurrency(input.value) : input.value}
          rows={rows}
          //disabled={this.props.isAdminFee}
          //disabled={disabled}
        />
        {monetaryValue ? (
          <InputGroupAddon className="monetary-value">
            {displayCurrency(monetaryValue)}
          </InputGroupAddon>
        ) : (
          ''
        )}
      </InputGroup>
    );
    return (
      <Row className={meta && meta.touched && meta.error ? ' has-error' : ''}>
        <Col sm={7} md={fieldSize ? fieldSize : 0}>
          {formControlComponent}
          {note ? <div className="note">{note}</div> : ''}
          {meta && meta.touched && meta.error && (
            <span className="input-error">{meta.error}</span>
          )}
        </Col>
        <Col sm={5} className={'admin-fee-button'}>
          <Button
            className="btn-padding-custom btn-custom-active"
            bsStyle="primary"
            label={'Apply'}
            // label={this.props.isAdminFee ? 'Clear' : 'Apply'}
            handleClick={this.props.handleApplyButton}
          />
        </Col>
      </Row>
    );
  }
}

export default OverrideFormControl;
